var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[(_vm.error_status === 404)?[_c('Error404')]:[_c('Error')]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }